import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@mts/ui';

function ProfileSidebar({ sections, activeSection }) {
  return (
    <Card
      padding="md"
      shadow="sm"
      className="hidden border lg:block"
      style={{
        backgroundColor: 'var(--surface)',
        borderColor: 'var(--border)',
      }}
    >
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.08em]" style={{ color: 'var(--page-body-color)' }}>
        Profile Sections
      </p>

      <nav className="space-y-1" aria-label="Profile sections">
        {sections.map((section) => {
          const isActive = section.id === activeSection;
          return (
            <Link
              key={section.id}
              to={`/profile/${section.id}`}
              className="block rounded-lg border px-3 py-2 text-sm transition-colors"
              style={{
                borderColor: isActive
                  ? 'color-mix(in srgb, var(--primary) 40%, var(--border))'
                  : 'transparent',
                backgroundColor: isActive
                  ? 'color-mix(in srgb, var(--primary) 9%, var(--surface))'
                  : 'transparent',
                color: isActive ? 'var(--primary)' : 'var(--page-heading-color)',
              }}
            >
              <p className="font-medium">{section.label}</p>
              <p className="mt-0.5 text-xs" style={{ color: 'var(--page-body-color)' }}>
                {section.description}
              </p>
            </Link>
          );
        })}
      </nav>
    </Card>
  );
}

export default ProfileSidebar;
